/**
 * Returns app state
 * @param {AppState} state
 *
 * @returns {{email: string, googleIdToken: string, isGoogleSignUp: boolean, isRegularSignUp: boolean, link: string, mobileLink: string}}
 */
function selectAppState(state) {
  return state.appState;
}

export default selectAppState;
